import SUBMISSION_OF_CO_CLASSIFIED_FILMS_FOR_EXHIBITION from './SubmissionOfCoClassifiedFilmsForExhibition';
import SUBMISSION_OF_CO_CLASSIFIED_TRAILERS_PRODUCT_ADVERTISEMENT_FOR_EXHIBITION from './SubmissionOfCoClassifiedTrailersProductAdvertisementForExhibition';
import SUBMISSION_OF_CO_CLASSIFIED_FILMS_FOR_DISTRIBUTION from './SubmissionOfCoClassifiedFilmsForDistribution';

const RCAFlow = [
    {
        formID: 'submissionOfCoClassifiedFilmsForExhibition',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_CO_CLASSIFIED_FILMS_FOR_EXHIBITION,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionOfCoClassifiedTrailersProductAdvertisementForExhibition',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_CO_CLASSIFIED_TRAILERS_PRODUCT_ADVERTISEMENT_FOR_EXHIBITION,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionOfCoClassifiedFilmsForDistribution',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_CO_CLASSIFIED_FILMS_FOR_DISTRIBUTION,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    }
];

export default RCAFlow;
